import { ITtsState } from 'store/types/tts'

export const getInitialState = (): ITtsState => ({
  ttsInitialItems: {
    data: [],
    isLoading: false
  },
  ttsMutableItems: {
    data: [],
    isLoading: false
  },
  languageOptions: { data: null, isLoading: false },
  speakersPerLangCode: null,
  speakerTones: { data: null, isLoading: false },
  ttsCredits: { data: 0, isLoading: false },
  ttsGenerationStatus: null,
  newGeneratedItemsInitialIdAndStatus: [],
  isTtsMismatchPopupVisible: false
})
